const fundApi = {
  GETFUNDDATA: '/fundInfo/queryFunds', //查询基金
  ADDFUNDSDATA: '/fundInfo/addFund', //添加基金
  DELECTFUNDSDATA: '/fundInfo/deleteFund', //删除基金
  QUERYFUNDAPPLYDATA: '/fundInfo/getAttachment', //查询基金申请条件数据
  UPDATEFUND: '/fundInfo/updateFund', //修改基金
  ADDAPPLYLIST: '/fundInfo/insertAttachment', //新增申请条件附件
  DELECTAPPLYLIST: '/fundInfo/deleteAttachment', //删除申请条件
  UPDATEAPPLYLIST: '/fundInfo/updateAttachment', //编辑申请条件
  GETAWARDS: '/matchAwardsRecordDo/awardPrizeInfo', //通过赛事id获取获奖情况
  GETSESSIONTAB: '/matchAwardsRecordDo/getSessionTab', //获奖赛事届数tab 入参
  UPDATEARARDNUMBER: '/matchAwardsRecordDo/updatePrizeInfo', //修改获奖信息 入参
  //外部服务模块
  outsideData: '/outterService/getServices', //获取外部服务
  EDITOUSIDEDATA: '/outterService/updateService',//修改外部服务
  GETFUNDMEMBER:'/fundInfo/getFundDetail',//基金的成员
  DELETEFUNDMEMBER:'/fundInfo/deleteDetail'
}

export default fundApi
